import styled from 'styled-components/macro';

const $Label = styled.label`
  font-size: ${({ theme, fontSize }) => theme.font.size.label[fontSize]};
`;

export default $Label;
